import React, { useState } from "react"
import { motion } from "framer-motion"
import tw, { styled } from "twin.macro"
import { Container } from "./misc/Layouts.jsx"
import { SectionHeading } from "./misc/Headings.jsx"
import feather from "./misc/feather.jsx"

const PrimaryBackgroundContainer = tw(Container)`-mx-8 px-8 `

const HeadingContainer = tw.div``
const Heading = tw(SectionHeading)``
const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto py-4 pb-24`

const FaqsContainer = tw.div` w-full flex-1 lg:flex justify-between items-start max-w-screen-xl mx-auto`
const FaqsColumn = tw.div`w-full  lg:mr-12 last:mr-0`
const Faq = tw.div`select-none cursor-pointer border-b-2 border-primary-300 hover:border-primary-500 transition-colors duration-300 py-6`
const Question = tw.div`flex justify-between items-center`
const QuestionText = tw.div`text-sm sm:text-lg font-semibold tracking-wide`
const QuestionToggleIcon = styled(motion.span)`
  ${tw`ml-2 transition duration-300`}
  svg {
    ${tw`w-6 h-6`}
  }
`
const Answer = tw(motion.div)`hidden text-sm font-normal mt-4 `

export default ({
  heading = "FAQ",
  service = "",
  aifaqs = [
    {
      question: "学習用のデータが少ないのですが、相談可能ですか？",
      answer:
        "はい。 課題や目的に合わせてデータソースの収集方法などからご相談可能です。",
    },
    {
      question: "どのような業種のクライアントが多いですか？",
      answer:
        "製造業から土木建築業といったクライアントから、メディア、ゲーム業界からの需要も増えてます。",
    },
    {
      question: "競合でもサービスは受けられますか？",
      answer: "はい。 Rossoは独自企業としてクライアントの制限はございません。",
    },
    {
      question: "準委任契約、もしくは請負契約での契約は可能ですか？",
      answer:
        "はい。 詳細についてご相談がございましたらお気軽にお問合せ下さい。",
    },
    {
      question: "運用面でも継続的にサポートを依頼できますか？",
      answer:
        "はい。 精度向上のため継続的なチューニング作業を含めサポートが可能です。",
    },
    {
      question: "AIだけでなくアプリケーション開発も可能ですか？",
      answer: "はい。webもしくはネイティブアプリの開発も可能です。",
    },
  ],
  cloudfaqs = [
    {
      question: "どのような業種のクライアントが多いですか？",
      answer:
        "製造業から土木建築業といったクライアントから、メディア、ゲーム業界からの需要も増えてます。",
    },
    {
      question: "競合でもサービスは受けられますか？",
      answer: "はい。 Rossoは独自企業としてクライアントの制限はございません。",
    },
    {
      question: "準委任契約、もしくは請負契約での契約は可能ですか？",
      answer:
        "はい。 詳細についてご相談がございましたらお気軽にお問合せ下さい。",
    },
    {
      question: "要件が固まっていないのですが調査目的でも相談は可能ですか？",
      answer: "はい。 課題などをご相談頂ければご提案まで無償で対応可能です。",
    },
    {
      question: "運用面でも継続的にサポートを依頼できますか？",
      answer: "はい。 運用保守プランもございますのでお気軽にお問合せ下さい。",
    },
    {
      question: "AWSのランニングコストの試算は可能ですか？",
      answer:
        "はい。ご利用プロダクトや構成、利用想定などを元に試算可能になります。",
    },
  ],
  contactaqs = [
    {
      question: "お問い合わせ後、どれくらいで返信いただけますか？",
      answer: "お問合せから24時間以内を目安に担当から返信させていただきます。",
    },
    {
      question: "web会議を希望しますが対応可能ですか？",
      answer: "はい。弊社では多様なweb会議ツールに対応しております。",
    },
    {
      question:
        "Rossoのサービスを支援したいのですが、どちらから連絡出来ますか？",
      answer: (
        <>
          弊社のサービス支援などのご相談は
          <a
            href="https://www.rosso-tokyo.co.jp/contact/"
            rel="noopener noreferrer"
            target="_blank"
            style={{ color: "blue" }}
          >
            こちら
          </a>
          からお問合せお願いいたします。
        </>
      ),
    },
    {
      question: "法人以外でもこのサービスは受けられますか？",
      answer: "いいえ。こちらは法人向けのサービスとなっております。",
    },
  ],
}) => {
  const faqCol1 = []
  const faqCol2 = []
  let faqs = {}
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null)

  const toggleQuestion = questionIndex => {
    if (activeQuestionIndex === questionIndex) setActiveQuestionIndex(null)
    else setActiveQuestionIndex(questionIndex)
  }

  switch (service) {
    case "ai":
      faqs = aifaqs
      break
    case "cloud":
      faqs = cloudfaqs
      break
    case "contact":
      faqs = contactaqs
      break
  }

  faqs.map((faq, index) => {
    const renderedFaq = (
      <Faq key={index} onClick={() => toggleQuestion(index)}>
        <Question>
          <QuestionText>{faq.question}</QuestionText>
          <QuestionToggleIcon
            variants={{
              collapsed: { rotate: 0 },
              open: { rotate: -180 },
            }}
            initial="collapsed"
            animate={activeQuestionIndex === index ? "open" : "collapsed"}
            transition={{ duration: 0.02, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            {feather("chevron-down", ["30", "30"])}
          </QuestionToggleIcon>
        </Question>
        <Answer
          variants={{
            open: {
              opacity: 1,
              height: "auto",
              marginTop: "16px",
              display: "block",
            },
            collapsed: {
              opacity: 0,
              height: 0,
              marginTop: "0px",
              display: "none",
            },
          }}
          initial="collapsed"
          animate={activeQuestionIndex === index ? "open" : "collapsed"}
          transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
        >
          {faq.answer}
        </Answer>
      </Faq>
    )

    if (index % 2 === 0) faqCol1.push(renderedFaq)
    else faqCol2.push(renderedFaq)

    return null
  })
  return (
    <PrimaryBackgroundContainer>
      <ContentWithPaddingXl>
        <HeadingContainer>
          <Heading>{heading}</Heading>
        </HeadingContainer>
        <FaqsContainer>
          <FaqsColumn>{faqCol1}</FaqsColumn>
          <FaqsColumn>{faqCol2}</FaqsColumn>
        </FaqsContainer>
      </ContentWithPaddingXl>
    </PrimaryBackgroundContainer>
  )
}
